export const initLoadingScreen = (selector: string = "loading-screen", timeout: number = 2000) => {
	const LoadingScreenObject = {
		el: document.getElementById(selector) as HTMLElement,
		timeout: timeout,

		_init(): void {
			if ( this.isMobile() ) {
				this.setCookie();
			}

			if ( this.hasCookie() ) {
				this.el?.remove();
				return;
			}

			this._bindClass();
			this._bindEvents();
		},

		_bindClass(): void {
			this.closeLoadingScreen = this.closeLoadingScreen.bind(this);
		},

		_bindEvents(): void {
			setTimeout(this.closeLoadingScreen, this.timeout);
		},

		closeLoadingScreen(): void {
			this.setCookie();
			this.el?.classList.add('loading-screen--closed');
			this.el?.addEventListener('transitionend', () => {
				this.el?.remove();
			}, {once: true});
		},

		hasCookie(): boolean {

			return document.cookie.split(';').some((item) => item.trim().startsWith('wvnderlab_loading_screen_closed='));
		},

		isMobile(): boolean {

			return window.matchMedia('(max-width: 767px)').matches;
		},

		setCookie(): void {
			document.cookie = "wvnderlab_loading_screen_closed=true; path=/";
		},


	};

	LoadingScreenObject._init();
	return LoadingScreenObject;
}
